"use client";

import { useState } from "react";
import { NoteIcon, PinIcon, PlusIcon } from "./icons";
import { IconButton, SectionLabel } from "./ui";

/* notes nav — obsidian-style file list for the notes sidebar */

interface Note {
  id: string;
  title: string;
  edited: string;
  pinned?: boolean;
}

const NOTES: Note[] = [
  { id: "vault", title: "Vault", edited: "2m", pinned: true },
  { id: "keys", title: "API keys", edited: "1h", pinned: true },
  { id: "ideas", title: "Ideas", edited: "3h" },
  { id: "cats", title: "Cat pics", edited: "5h" },
  { id: "dnd", title: "D&D plans", edited: "1d" },
  { id: "todo", title: "Todo", edited: "1d" },
  { id: "dream", title: "Dream log", edited: "3d" },
  { id: "gifts", title: "Gift list", edited: "4d" },
  { id: "secrets", title: "Secrets", edited: "1w" },
  { id: "hw", title: "Homework", edited: "2w" },
];

export function NotesList() {
  const [active, setActive] = useState("vault");
  const pinned = NOTES.filter((n) => n.pinned);
  const rest = NOTES.filter((n) => !n.pinned);

  const row = (n: Note) => (
    <li key={n.id}>
      <button
        type="button"
        onClick={() => setActive(n.id)}
        className={`flex w-full items-center gap-2.5 rounded-lg px-2.5 py-1.5 text-left transition ${
          active === n.id ? "bg-raise" : "hover:bg-raise"
        }`}
      >
        <NoteIcon
          className={`h-4.5 w-4.5 shrink-0 ${
            active === n.id ? "text-accent" : "text-fg-faint"
          }`}
        />
        <span className="min-w-0 flex-1">
          <span
            className={`block truncate text-note font-semibold ${
              active === n.id ? "text-fg" : "text-fg-dim"
            }`}
          >
            {n.title}
          </span>
          <span className="block text-micro leading-tight text-fg-faint">
            edited {n.edited} ago
          </span>
        </span>
        {n.pinned ? (
          <PinIcon className="h-3.5 w-3.5 shrink-0 text-fg-faint" />
        ) : null}
      </button>
    </li>
  );

  return (
    <div className="flex flex-col px-2 pb-4">
      <div className="flex items-center justify-between pr-1">
        <SectionLabel>Notes - {NOTES.length}</SectionLabel>
        <IconButton
          label="New note"
          tip="New note"
          size="sm"
          className="my-2"
        >
          <PlusIcon className="h-4 w-4" />
        </IconButton>
      </div>
      <SectionLabel>Pinned</SectionLabel>
      <ul className="space-y-0.5">{pinned.map(row)}</ul>
      <SectionLabel>All notes</SectionLabel>
      <ul className="space-y-0.5">{rest.map(row)}</ul>
    </div>
  );
}
